module.exports = __webpack_public_path__ + "static/media/imagemECM.0c10565e.svg";